module.exports = __webpack_public_path__ + "img/aya_1x1.56398f86.jpg";